/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Capture_Hint_BackgroundInputs */

const en_us2_body_assessment_capture_hint_background = /** @type {(inputs: Body_Assessment_Capture_Hint_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A plain background that contrasts with your clothes, good light, no backlight.`)
};

const pt_br2_body_assessment_capture_hint_background = /** @type {(inputs: Body_Assessment_Capture_Hint_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundo liso que contraste com a roupa, boa luz e nada de contraluz.`)
};

const es_419_body_assessment_capture_hint_background = /** @type {(inputs: Body_Assessment_Capture_Hint_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un fondo liso que contraste con tu ropa, buena luz y nada de contraluz.`)
};

const pt_pt2_body_assessment_capture_hint_background = /** @type {(inputs: Body_Assessment_Capture_Hint_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundo liso que contraste com a roupa, boa luz e nada de contraluz.`)
};

const fr_fr2_body_assessment_capture_hint_background = /** @type {(inputs: Body_Assessment_Capture_Hint_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un fond uni qui contraste avec tes vêtements, une bonne lumière, pas de contre-jour.`)
};

const de_de2_body_assessment_capture_hint_background = /** @type {(inputs: Body_Assessment_Capture_Hint_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein schlichter Hintergrund, der sich von deiner Kleidung abhebt, gutes Licht, kein Gegenlicht.`)
};

const it_it2_body_assessment_capture_hint_background = /** @type {(inputs: Body_Assessment_Capture_Hint_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uno sfondo uniforme che contrasti con gli abiti, buona luce e niente controluce.`)
};

/**
* | output |
* | --- |
* | "A plain background that contrasts with your clothes, good light, no backlight." |
*
* @param {Body_Assessment_Capture_Hint_BackgroundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_capture_hint_background = /** @type {((inputs?: Body_Assessment_Capture_Hint_BackgroundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Capture_Hint_BackgroundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_capture_hint_background(inputs)
	if (locale === "es-419") return es_419_body_assessment_capture_hint_background(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_capture_hint_background(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_capture_hint_background(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_capture_hint_background(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_capture_hint_background(inputs)
	return en_us2_body_assessment_capture_hint_background(inputs)
});
export { body_assessment_capture_hint_background as "body-assessment.capture_hint_background" }